import { ReactNode } from "react";

import ArrowRight from "shared/assets/svg/arrow-right.svg?react";

type Props = {
  image: ReactNode;
  text: string;
  onClick: () => void;
};

export const Row = (props: Props) => {
  const { image, text, onClick } = props;
  return (
    <div
      className="text-balticSea flex w-full cursor-pointer items-center gap-x-3 px-6 py-3"
      onClick={onClick}
    >
      <div className="flex size-6.5 shrink-0 items-center">{image}</div>
      <span className="leading-6 font-medium">{text}</span>

      <button className="ml-auto flex size-6 cursor-pointer items-center justify-center text-black hover:brightness-125">
        <ArrowRight className="size-3.5 transition-colors" />
      </button>
    </div>
  );
};
